export enum ContactVerificationType {
    ByUser = 0,
    ByRegistrator = 1,
    ByAdministrator = 2,
}
